import { Repeat, CheckCircle2, MapPin } from "lucide-react";
import Reveal from "../Reveal";

const Rail = () => (
  <div className="relative mx-2 hidden h-px flex-1 self-center bg-[#CBD8EA] md:block" aria-hidden="true">
    <span className="sw-travel-dot" style={{ top: "-3.5px" }} />
    <span className="sw-travel-dot" style={{ top: "-3.5px", animationDelay: "1.6s" }} />
  </div>
);

const RailMobile = () => (
  <div className="relative mx-auto my-1 h-8 w-px bg-[#CBD8EA] md:hidden" aria-hidden="true">
    <span className="sw-travel-dot-y" />
  </div>
);

const StepCard = ({ eyebrow, title, amount, highlight = false, done = false }) => (
  <div
    className={`flex w-full flex-col items-center justify-center rounded-2xl border px-6 py-5 text-center md:h-[136px] md:w-[176px] ${
      highlight
        ? "border-transparent bg-gradient-to-br from-[#1E3A6E] to-[#2E7CD6] text-white shadow-xl shadow-[#2E7CD6]/25"
        : "border-[#E2E8F0] bg-white shadow-sm"
    }`}
  >
    <p className={`text-[11px] font-semibold uppercase tracking-wider ${highlight ? "text-blue-100" : "text-[#64748B]"}`}>{eyebrow}</p>
    <p className={`mt-1.5 font-heading text-lg font-bold ${highlight ? "text-white" : "text-[#0F172A]"}`}>{title}</p>
    {amount && <p className={`mt-1 text-sm ${highlight ? "text-blue-100" : "text-[#64748B]"}`}>{amount}</p>}
    {done && (
      <p className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-600">
        <CheckCircle2 size={13} strokeWidth={2} /> Delivered
      </p>
    )}
  </div>
);

const GlobalMovement = () => (
  <div data-testid="global-movement-visual" className="relative">
    <div className="flex flex-col items-center md:flex-row md:items-stretch md:justify-center">
      <Reveal><StepCard eyebrow="Origin" title="United States" amount="$25,000 USD" /></Reveal>
      <Rail /><RailMobile />
      <Reveal delay={0.1}>
        <div className="w-full md:w-auto md:self-center">
          <StepCard eyebrow="Routes through" title="Swiftwire" amount="" highlight />
        </div>
      </Reveal>
      <Rail /><RailMobile />
      <Reveal delay={0.2}>
        <div className="flex w-full flex-col items-center justify-center rounded-2xl border border-[#E2E8F0] bg-white px-6 py-5 text-center shadow-sm md:h-[136px] md:w-[176px]">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-[#64748B]">FX</p>
          <p className="mt-1.5 flex items-center justify-center gap-2 font-heading text-lg font-bold text-[#0F172A]">
            USD <Repeat size={15} strokeWidth={1.5} className="text-[#2E7CD6]" /> NGN
          </p>
          <p className="mt-1 text-sm text-[#64748B]">Converted</p>
        </div>
      </Reveal>
      <Rail /><RailMobile />
      <Reveal delay={0.3}>
        <div className="w-full md:w-auto md:self-center">
          <StepCard eyebrow="Destination" title="Nigeria" amount="₦38,450,000" />
        </div>
      </Reveal>
      <Rail /><RailMobile />
      <Reveal delay={0.4}>
        <div className="flex w-full flex-col items-center justify-center rounded-2xl border border-emerald-100 bg-emerald-50/60 px-6 py-5 md:h-[136px] md:w-[176px]">
          <p className="flex items-center justify-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-emerald-700">
            <MapPin size={12} strokeWidth={2} /> Status
          </p>
          <p className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-4 py-1.5 text-sm font-semibold text-white">
            <CheckCircle2 size={14} strokeWidth={2} /> Delivered
          </p>
        </div>
      </Reveal>
    </div>
    <p className="mt-8 text-center text-xs text-[#94A3B8]">Illustrative money movement flow</p>
  </div>
);

export default GlobalMovement;
